module.exports = __webpack_public_path__ + "static/media/Checkliste Aufnahme.338ad1c6.pdf";